import { useQuery } from '@tanstack/react-query';

import { KEYS } from '~shared/api/query-keys';

import { baseAPI } from '../../../shared/api/base-api';

export interface StripeIntegrationStatus {
  hasLegacyKeys: boolean;
  hasStripeConnect: boolean;
  hasSquareConnect: boolean;
}

export const getStripeIntegrationStatusAPI = async (
  studioId: string,
): Promise<StripeIntegrationStatus> => {
  const resp = await baseAPI.get<StripeIntegrationStatus>(
    `/payment-processor/credential/studio/${studioId}`,
  );
  return resp.data;
};

export const useGetStripeCredentials = (
  studioId: string,
  options = { enabled: true },
) => {
  return useQuery({
    queryKey: [KEYS.STRIPE, KEYS.CREDENTIALS, studioId],
    queryFn: () => getStripeIntegrationStatusAPI(studioId),
    enabled: options.enabled && !!studioId,
  });
};
